"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _default = function _default(a) {
  var b = !!(1 < arguments.length && void 0 !== arguments[1]) && arguments[1],
    c = a.rules,
    d = a.actionType;
  if (!c) return !0;
  for (var e = b || e, f = "hide" !== d, g = [], h = 0; h < c.length; h++) {
    var j = c[h],
      k = j.fieldId,
      l = j.value,
      m = j.operator,
      n = e[k].value && e[k].value.value ? e[k].value.value : e[k].value || !1,
      o = Array.isArray(n) ? n.join("") : n;
    g[h] = l ? o && l === o ? "hide" === d : o && o.includes(l) ? "hide" === d : "hide" !== d : o || l ? "hide" !== d : "hide" === d, "isnot" === m && (g[h] = !g[h]);
  }
  return f = g.every(function (a) {
    return !0 === a;
  }), f;
};
exports["default"] = _default;